/*

---- 提示框 ----
this.$alert({
	// title: '提示',
	message: '内容',
	// btn: '确定',
}).then(()=>{
	console.log('点击了确定')
})

---- 确认框 ----
this.$confirm({
	// title: '提示',
	message: '内容',
	// btn: '确定',
	// btn2: '取消',
}).then(()=>{
	console.log('点击了确定')
}).catch(()=>{
	console.log('点击了取消')
})

*/

import Vue from 'vue'
import alert from './alert.vue'

let alertControl = Vue.extend(alert)
let alertDom = new alertControl({
	el: document.createElement('div'),
})
document.body.appendChild(alertDom.$el)

let alertQueue = []
let alertOption = {
	title: '提示',
	message: '',
	btn: '我知道了',
	btn2: '取消',
}
let confirmOption = {
	title: '提示',
	message: '',
	btn: '确定',
	btn2: '取消',
}

let alertCheck =()=>{
	setTimeout(()=>{
		if(alertQueue.length>0){
			let data = Object.assign({},alertQueue[0])
			if(data.option.isConfirm==1){
				confirmModal(data.option,data.resolve,data.reject)
			}else{
				alertModal(data.option,data.resolve)
			}
			alertQueue.splice(0,1)
		}
	},300)
}
let alertModal = (o,resolve_fun) => {
	return new Promise((resolve, reject) => {
		// if((alertDom.option.message=='登录失效，请先登录'||JSON.stringify(alertQueue).indexOf('登录失效，请先登录')>=0)&&o.message=='登录失效，请先登录'){ // 取消重复弹出登录失效弹窗
		// 	return
		// }

		if(alertDom.has){
			o.isConfirm = 0
			alertQueue.push({
				option: o,
				resolve: resolve,
				reject: reject,
			})
			return
		}

		let option = Object.assign({},alertOption,o)
		option.resolve = (resolve_fun?resolve_fun:resolve)
		option.reject = null

		option.btnCall = ()=>{
			alertCheck()
			option.resolve()
		}
		option.btnCall2 = null
		option.isConfirm = 0

		alertDom.has = true
		alertDom.option = option
	})
}

let confirmModal = (o,resolve_fun,reject_fun) => {
	return new Promise((resolve, reject) => {
		if(alertDom.has){
			o.isConfirm = 1
			alertQueue.push({
				option: o,
				resolve: resolve,
				reject: reject,
			})
			return
		}

		let option = Object.assign({},confirmOption,o)
		option.resolve = (resolve_fun?resolve_fun:resolve)
		option.reject = (reject_fun?reject_fun:reject)

		option.btnCall = ()=>{
			alertCheck()
			option.resolve()
		}
		option.btnCall2 = ()=>{
			alertCheck()
			option.reject()
		}
		option.isConfirm = 1

		alertDom.has = true
		alertDom.option = option
	})
}

export default {
	alertModal,
	confirmModal,
}


// WEBPACK FOOTER //
// ./src/components/alert/alert.js